export const getRandomNumber = (max: number): number => {
  return Math.floor(Math.random() * max)
}

export const getRandomNumberFromInterval = (
  min: number,
  max: number,
): number => {
  return Math.floor(Math.random() * (max - min + 1) + min)
}
